/**
 * Kolumny tabeli z polem visibleTo — widoczne tylko gdy użytkownik ma jedną z wymaganych ról.
 */
export default function filterTableColumnsByRoles(tableColumns, userRoles) {
  if (!userRoles || !userRoles.length) {
    return tableColumns.filter(column => !column.visibleTo)
  }

  return tableColumns.filter(column => {
    if (!column.visibleTo) {
      return true
    }
    return column.visibleTo.some(requiredRole => userRoles.includes(requiredRole))
  })
}
